import { Urls } from '../constants/urls.constants';

export default function LogoImages({ isDarkBackground = false }) {
  const westernBidImage = isDarkBackground ? "images/Group-19977.svg" : "images/Group-19664.svg";
  
  return (
    <>
      <a href={Urls.WesternBid}>
        <img src={westernBidImage} loading="lazy" alt="" className="tracker-logo-image is--1" />
      </a>
    </>
  );
}